/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropTwitchScheduleSegmentResponse } from './DropTwitchScheduleSegmentResponse';
import {
    DropTwitchScheduleSegmentResponseFromJSON,
    DropTwitchScheduleSegmentResponseFromJSONTyped,
    DropTwitchScheduleSegmentResponseToJSON,
    DropTwitchScheduleSegmentResponseToJSONTyped,
} from './DropTwitchScheduleSegmentResponse';

/**
 * 
 * @export
 * @interface DropTwitchScheduleResponse
 */
export interface DropTwitchScheduleResponse {
    /**
     * 
     * @type {string}
     * @memberof DropTwitchScheduleResponse
     */
    channelId: string | null;
    /**
     * 
     * @type {Array<DropTwitchScheduleSegmentResponse>}
     * @memberof DropTwitchScheduleResponse
     */
    segments: Array<DropTwitchScheduleSegmentResponse>;
    /**
     * 
     * @type {number}
     * @memberof DropTwitchScheduleResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropTwitchScheduleResponse interface.
 */
export function instanceOfDropTwitchScheduleResponse(value: object): value is DropTwitchScheduleResponse {
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('segments' in value) || value['segments'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropTwitchScheduleResponseFromJSON(json: any): DropTwitchScheduleResponse {
    return DropTwitchScheduleResponseFromJSONTyped(json, false);
}

export function DropTwitchScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropTwitchScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'channelId': json['channelId'],
        'segments': ((json['segments'] as Array<any>).map(DropTwitchScheduleSegmentResponseFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropTwitchScheduleResponseToJSON(json: any): DropTwitchScheduleResponse {
    return DropTwitchScheduleResponseToJSONTyped(json, false);
}

export function DropTwitchScheduleResponseToJSONTyped(value?: DropTwitchScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channelId': value['channelId'],
        'segments': ((value['segments'] as Array<any>).map(DropTwitchScheduleSegmentResponseToJSON)),
        'computedAt': value['computedAt'],
    };
}

